import { generatePath } from "react-router-dom";
import { deserialize } from "serializr";
import axiosInstance from "../../interceptor/axiosInstance";
import _axiosInstance from "../../interceptor/_axiosInstance";
import { InstituteLeaderboard } from "../../models/InstituteModel/leaderboard.model";
import { INSTITUTE_LEADERBOARD } from "../../routes/routeConstants/apiRoutes";

export class InstituteLeaderboardService {
  static fetchLeaderboardData(
    StudentId: number,
    onSuccess: (value: InstituteLeaderboard) => void,
    onError: Function,
    onFinal: () => void
  ) {  
    return _axiosInstance
      .get(INSTITUTE_LEADERBOARD, {
        params: {
          'StudentId': StudentId
        }
      })
      .then((response) => {
        const data = deserialize(
          InstituteLeaderboard,
          response["data"]?.['studentLeaderboard']
        );
        onSuccess(data);
      })
      .catch((e) => {
        console.log(e);
        
        onError(e);
      })
      .finally(onFinal);
  }
}
